import * as React from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "components/common";
import ExpandedSectionCount from "components/common/EntityDataTable/ExpandedSectionCount";
import { useForwarderInputMetricsFor } from "../ForwarderInputMetricsContext";
import { METRIC_COLUMN_IDS } from "../metricColumns";
const SECTION_NAME = METRIC_COLUMN_IDS.messagesPerStream;
const sumValues = (counts) => Object.values(counts).reduce((sum, value) => sum + value, 0);
const MessageCountCell = ({ input }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const { metrics, isInitialLoading, isError } = useForwarderInputMetricsFor(input.input_id, input.forwarder_node_id);
  if (isInitialLoading && !metrics) {
    return /* @__PURE__ */ React.createElement(Spinner, { size: "xs" });
  }
  if (isError || !(metrics == null ? void 0 : metrics.messages_per_stream)) {
    return /* @__PURE__ */ React.createElement("span", { "aria-label": t("message_count_cell.no_message_count_aria", { title: input.title }) }, "\u2014");
  }
  const total = sumValues(metrics.messages_per_stream);
  return /* @__PURE__ */ React.createElement(
    ExpandedSectionCount,
    {
      entityId: input.id,
      section: SECTION_NAME,
      count: total,
      label: t("message_count_cell.section_label", { title: input.title })
    }
  );
};
export default MessageCountCell;
